import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';

import { CustomerSearch } from '../../../common/Selectors';
import { ClientSearchIcon } from '../../../common/icons/ClientSearchIcon';
import { NavStyles } from '.';
import { Tooltip } from '@mui/material';

const ClientSearch = props => {
  const navClasses = NavStyles();
  const { isNavOpen, setIsNavOpen } = props;
  const navigate = useNavigate();

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [wasNavClosed, setWasNavClosed] = useState(false);

  const handleButtonClick = () => {
    if (!isNavOpen) {
      setWasNavClosed(true);
    }
    setIsNavOpen(true);
    setIsSearchOpen(true);
  };

  const revertNavState = () => {
    if (wasNavClosed) {
      setIsNavOpen(false);
      setWasNavClosed(false);
    }
  };

  const handleBlur = () => {
    setIsSearchOpen(false);
    revertNavState();
  };

  const visitProfile = id => {
    navigate(`/customer/profile/${id}`);
    revertNavState();
  };

  return (
    <Tooltip title={isNavOpen ? '' : 'Client Search'} placement="right">
      <ListItem key={'search'} disablePadding sx={{ display: 'block' }}>
        {!isSearchOpen ? (
          <ListItemButton
            className={navClasses.linkButton}
            onClick={handleButtonClick}
            sx={{
              justifyContent: isNavOpen ? 'initial' : 'center'
            }}
          >
            <ListItemIcon
              className={navClasses.linkIcon}
              sx={{ mr: isNavOpen ? 2 : 'auto' }}
            >
              <ClientSearchIcon />
            </ListItemIcon>
            <ListItemText
              primary={isNavOpen ? 'Client Search' : ''}
              classes={{ primary: navClasses.linkText }}
              sx={{ opacity: isNavOpen ? 1 : 0 }}
            />
          </ListItemButton>
        ) : (
          <CustomerSearch
            classes={navClasses.leftNavSearch}
            clearOnSelect={true}
            onChange={customer => visitProfile(customer.id)}
            handleBlur={handleBlur}
            navSearch
            autoFocus
          />
        )}
      </ListItem>
    </Tooltip>
  );
};

export default ClientSearch;
